// extracted by mini-css-extract-plugin
module.exports = {"photosList":"photos-module--photosList--3Y_KD","inline":"photos-module--inline--2yjj4"};